import React from 'react';
import logo from '../assets/img/logo-white.svg';
import {Link} from 'react-router-dom';

const LogoWhite = (props: { width: number }) => {
  return (
          <Link to={'/'}>
            <img src={logo} width={props.width} alt="Smart all in"/>
          </Link>
  );
};

LogoWhite.defaultProps = {
  width: 198,
}

export default LogoWhite;
